import React, { useEffect, useState } from 'react';
import { Check, Filter, Loader2, Megaphone } from 'lucide-react';
import { Account } from '../../types/client-management.types';
import { Company } from 'src/pages/billing/types/billing.types';


interface AccountMultiSelectorProps {
  isLoading: boolean;
  accounts: Account[];
  selectedAccounts: Account[];
  onAccountSelect: (account: Account) => void;
  companies: Company[];
}

const AccountMultiSelector: React.FC<AccountMultiSelectorProps> = ({
  isLoading,
  accounts,
  selectedAccounts,
  onAccountSelect,
  companies,
}) => {

  const [showOnlySelectedAccounts, setShowOnlySelectedAccounts] = useState(false);
  const [filteredAccounts, setFilteredAccounts] = useState<Account[]>([]);
  const [accountFilter, setAccountFilter] = useState('');

  const handleAccountFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAccountFilter(e.target.value);
  };

  useEffect(() => {
    if (accountFilter.length === 0) {
      setFilteredAccounts(showOnlySelectedAccounts ? selectedAccounts : accounts);
    } else {
      setFilteredAccounts(accounts.filter((account) => account.title.toLowerCase().includes(accountFilter.toLowerCase())));
      showOnlySelectedAccounts ? setFilteredAccounts(selectedAccounts.filter((account) => account.title.toLowerCase().includes(accountFilter.toLowerCase()))) : setFilteredAccounts(accounts.filter((account) => account.title.toLowerCase().includes(accountFilter.toLowerCase())));
    }
  }, [accountFilter, accounts, showOnlySelectedAccounts, selectedAccounts]);

  return (
    <div className='w-1/3 bg-white rounded-md overflow-hidden shadow-sm mb-1'>
      <div className='flex flex-col'>
        <div className='flex flex-row items-center bg-gray-201 font-medium text-black p-2 gap-2 pl-4 borber-b border-green-501 border-b-2 pb-1 justify-between'>
          <div className='flex flex-row items-center gap-2'>
            <Megaphone className='size-4' />
            <span className=''>
              Accounts
            </span>
          </div>
          <div className='flex flex-row items-center gap-2'>
            {selectedAccounts.length > 0 && showOnlySelectedAccounts ? (
              <Filter
                className='size-5 cursor-pointer text-white bg-blue-500 rounded-sm p-0.5'
                onClick={() => setShowOnlySelectedAccounts(!showOnlySelectedAccounts)}
              />
            ) : (
              <Filter
                className='size-4 cursor-pointer'
                onClick={() => setShowOnlySelectedAccounts(!showOnlySelectedAccounts)}
              />
            )}
          </div>
        </div>
        {isLoading ? (
          <div className='flex flex-row items-center gap-2 h-[200px] justify-center'>
            <Loader2 className='size-10 animate-spin' />
          </div>
        ) : (
          <div className='flex flex-col h-[200px] bg-white no-wrap overflow-y-auto'>
            <input
              type="text"
              onChange={handleAccountFilter}
              placeholder='Search accounts'
              className='w-full border-b border-gray-201 bg-white px-2 py-1 mr-2 mb-1 text-sm focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-transparent'
            />
            { filteredAccounts.length > 0 ? filteredAccounts.map((account) => (
              <div
                key={account.id}
                onClick={() => onAccountSelect(account)}
                className='flex flex-row items-center text-sm py-1 cursor-pointer hover:bg-gray-201'
              >
                <div className='flex-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                  <div className='truncate'>
                    {account.title}
                  </div>
                  <div className='text-xs text-gray-500'>

                    <span className='text-blue-500'>
                      {companies.find((company) => company.id === account.company)?.company_name || ''}
                    </span>
                    <span className='text-xs text-gray-500 ml-1 p-1 px-2 underline'>
                      {account.source.toLocaleLowerCase().replace('_', ' ')}
                    </span>
                  </div>
                </div>
                {selectedAccounts.includes(account) ? <Check className='size-4 mr-2 flex-shrink-0 text-green-501' /> : null}
              </div>
            )) : (
              <div className='text-sm text-gray-500 text-center h-[200px] flex items-center justify-center'>
                <Megaphone className='size-4 mr-1' />
                No accounts found
              </div>
            ) }
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountMultiSelector;
